import ErrorBoundary from './view';

// TODO: bring in device/user(?) info in the future
export default ErrorBoundary;
